module.exports = __webpack_public_path__ + "media/images/faces/face7-44c7feaf00a394ea11d04e83e87ccae6.jpg";